import _ from "lodash";
import {
  ClaimOwnerShipForFilter,
  ALL_FILTER_ID,
  SavedFilterStatus,
} from "../Constants";
import { FollowUpEntityType } from "us.collection.followup/constants";
import { EntityType } from "us.common/constants";

export function SaveFollowUpFilters(this: any): any {
  const caseStates = _.keys(_.pickBy(this?.caseStates, _.identity))
    ?.map((key) => key?.toUpperCase())
    ?.join(",");

  return {
    filterId: this.filterId ? Number(this.filterId) : ALL_FILTER_ID,
    filterName: this.filterName,
    caseType:
      this.entityType == FollowUpEntityType.CASE
        ? EntityType.CASE?.toUpperCase()
        : EntityType.SUB_CASE?.toUpperCase(),
    reasonIds: this.selectedReasons ? this.selectedReasons?.join(",") : "",
    extendedFilters: "",
    status: caseStates == "" ? SavedFilterStatus.OPEN : caseStates,
    claimOwnerShip: this.userOwnedClaims
      ? ClaimOwnerShipForFilter.MY
      : ClaimOwnerShipForFilter.ALL,
    followupId: this.followUpId ? Number(this.followUpId) : -1,
    caseHandlers: this.selectedCaseHandlers
      ? this.selectedCaseHandlers
          ?.filter((handler: number) => handler != -1)
          .join(",")
      : "",
    currentUser : this.currentUserEmail ?? ''
  };
}
